import { track } from './amplitude';
import { Feilmelding } from './amplitude/ampli';
import { getUserLanguage } from './hn-language';
import { HelsenorgeHttpError } from './hn-proxy-service';
import { checkStatus, createBaseHeaders, createQueryString } from './hn-service';
import { warn } from './logger';
/**
 * Returnerer CmsContentApiUrl fra window.HN.Rest
 */
export const getContentApiUrl = () => {
    return !!window.HN && !!window.HN.Rest && !!window.HN.Rest.CmsContentApiUrl ? window.HN.Rest.CmsContentApiUrl : '';
};
/**
 * Returnerer CmsContentApiPreviewUrl fra window.HN.Rest
 */
export const getContentApiPreviewUrl = () => {
    return !!window.HN && !!window.HN.Rest && !!window.HN.Rest.CmsContentApiPreviewUrl ? window.HN.Rest.CmsContentApiPreviewUrl : '';
};
/**
 * Returnerer true dersom URLen man står på inneholder content-api-preview=true
 */
export const enableContentApiPreview = () => {
    return !!window && window.location.href.indexOf('content-api-preview=true') !== -1;
};
export const handleError = (error, apiUrl) => {
    track(new Feilmelding({
        handling: 'systemevent',
        feiltype: 'nivå 1: teknisk feil',
        feilkode: error instanceof HelsenorgeHttpError ? error.statusCode.toString() : undefined,
        feilmelding: 'Feil ved henting av data fra CMS',
    }));
    if (error instanceof TypeError && error.message === 'Failed to fetch') {
        warn(`Kall til content-apiet feilet: ${apiUrl}. Mottok ingen respons fra tjenesten.`);
    }
    else if (error instanceof Error) {
        warn(`Kall til content-apiet feilet: ${apiUrl}`, error);
    }
    throw error;
};
export var CmsContentApiVersions;
(function (CmsContentApiVersions) {
    CmsContentApiVersions["V1"] = "v1/";
    CmsContentApiVersions["V2"] = "v2/";
})(CmsContentApiVersions || (CmsContentApiVersions = {}));
/**
 * Henter JSON fra content-apiet med fetch(). Returnerer et Promise.
 * Logger eventuelle feil med warn().
 * @param endpoint command strengen som sendes mot content-apiet
 * @param params object med parameters { param1 : 'myparam1', param2: 'myparam2'}
 * @param version setter hvilken versjon av conetnapi som skal kalles (v1/, v2/)
 * @throws {Error} Dersom det skjedde en feil under henting av data fra content-apiet.
 */
export const get = (endpoint, params = {}, version = CmsContentApiVersions.V1) => {
    const preview = enableContentApiPreview();
    const hostName = preview ? getContentApiPreviewUrl() : getContentApiUrl();
    const credentials = preview ? 'include' : 'same-origin'; // same-origin sender cookies kun når content-apiet er på samme domene (f.eks. redaktørdomenet). Ikke bruk include, da virker ikke wildcard (*) i CORS.
    const headers = createBaseHeaders('application/json', 'GET'); // Må bruke GET-metoden for å unngå å sette 'Content-Type'
    if (preview) {
        headers.append('X-Preview', 'true');
    }
    const { languageCode = getUserLanguage(), ...restParams } = params;
    const apiUrl = `${hostName}/contentapi/internal/${version}${endpoint}${createQueryString({ languageCode, ...restParams })}`;
    return fetch(apiUrl, {
        method: 'GET',
        credentials,
        headers: headers,
    })
        .then(response => checkStatus(response))
        .catch(error => handleError(error, apiUrl));
};
/**
 * Send JSON til CMS-apiet med fetch() som POST-request. Returnerer et Promise.
 * Logger eventuelle feil med warn().
 * @param endpoint command strengen som sendes mot apiet
 * @param data object med data { param1 : 'myparam1', param2: 'myparam2'}
 * @param params object med parameters { param1 : 'myparam1', param2: 'myparam2'}
 * @throws {Error} Dersom det skjedde en feil under henting av data fra content-apiet.
 */
export const post = (endpoint, data, params = {}) => {
    const hostName = getContentApiUrl();
    const headers = createBaseHeaders();
    const apiUrl = `${hostName}/api/${endpoint}${createQueryString(params)}`;
    return fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data),
    })
        .then(response => checkStatus(response))
        .catch(error => handleError(error, apiUrl));
};
/**
 * Send JSON til CMS-apiet med fetch() som PATCH-request. Returnerer et Promise.
 * Logger eventuelle feil med warn().
 * @param endpoint command strengen som sendes mot apiet
 * @param data object med data { param1 : 'myparam1', param2: 'myparam2'}
 * @param params object med parameters { param1 : 'myparam1', param2: 'myparam2'}
 * @throws {Error} Dersom det skjedde en feil under henting av data fra content-apiet.
 */
export const patch = (endpoint, data, params = {}) => {
    const hostName = getContentApiUrl();
    const headers = createBaseHeaders();
    const apiUrl = `${hostName}/api/${endpoint}${createQueryString(params)}`;
    return fetch(apiUrl, {
        method: 'PATCH',
        headers: headers,
        body: JSON.stringify(data),
    })
        .then(response => checkStatus(response))
        .catch(error => handleError(error, apiUrl));
};
